import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  GridComponent,
  Inject,
  Page,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import React, { useCallback, useEffect, useState } from "react";
import { BsCheck2Circle, BsPencilSquare } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import Layout from "../components/Layout";
import { useLazyGetFormQuery } from "../redux/formService";
import { useLazyGetParamsQuery } from "../redux/paramService";
import {
  useDeleteUserMutation,
  useLazyGetUsersBlockedQuery,
  useLazyGetUsersQuery,
  usePostUserMutation,
  useUpdateUserMutation,
} from "../redux/userServices";
import Form from "./../components/Form";
import Modal1 from "./../components/Modal1";
import { MdDelete } from "react-icons/md";
import ConfirmDelete from "../components/ConfirmDelete";
import Pagination from "../components/Pagination";
import { ConfirmActivation } from "../components";

const Users = () => {
  const [fields, setFields] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selected, setSelected] = useState();
  const [showUsager, setShowUsager] = useState(false);
  const [getParams, { data: paramsData }] = useLazyGetParamsQuery();
  const [postUsers] = usePostUserMutation();
  const [updateUser] = useUpdateUserMutation();
  const [showActivation, setShowActivation] = useState(false)

  const gridDate = (props) => (
    <div className="flex items-center justify-center gap-2">
      {/* <GrLocation /> */}
      <span>{new Date(props?.createdAt).toLocaleDateString()}</span>
    </div>
  );
  const usersGrid = [
    {
      headerText: "N",
      field: "id",
      width: "40",
      textAlign: "Center",
    },
    {
      field: "username",
      headerText: "Nom",
      width: "70",
      textAlign: "Center",
    },
    {
      field: "email",
      headerText: "Email",
      width: "70",
      textAlign: "Center",
    },
    {
      field: "phone",
      headerText: "Téléphone",
      width: "70",
      textAlign: "Center",
    },

    {
      field: "bureau.name",
      headerText: "Bureau",
      width: "80",
      textAlign: "Center",
    },
    {
      field: "role.name",
      headerText: "Role",
      width: "80",
      textAlign: "Center",
    },
    {
      headerText: "Date d'ajout",
      width: "90",
      textAlign: "Center",
      template: gridDate,
    },
  ];

  const [getUsers, { data: usersData, error, isLoading }] =
    useLazyGetUsersQuery();

  const [getUsersBlocked, { data: usersBlockedData }] =
    useLazyGetUsersBlockedQuery();
  const [showDelete, setShowDelete] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState("activé");
  const [deleteUser] = useDeleteUserMutation();
  const [fetchedPage, setFetchedPage] = useState({ page: 1, size: 10 });

  console.log("userData", usersData);

  const [getForm, { data: formData, isLoading: isFormLoading }] =
    useLazyGetFormQuery();

  const handleShowModal = useCallback((props) => {
    console.log("props", props);
    setSelected(props);
    localStorage.setItem("redevance", JSON.stringify(props));
    console.log("les champs", fields);

    setShowForm(true);
  }, []);

  const handleShowUsager = useCallback((props) => {
    console.log("props", props);

    setSelected(props);
    localStorage.setItem("redevance", JSON.stringify(props));
    setShowUsager(true);
  }, []);

  const handleShowDelete = useCallback((props) => {
    console.log("props", props);
    setSelected(props);
    localStorage.setItem("redevance", JSON.stringify(props));
    setShowDelete(true);
    // setShowForm(true);
  }, []);

  const handleShowActivation = useCallback((props) => {
    console.log("props", props);
    setSelected(props);
    localStorage.setItem("redevance", JSON.stringify(props));
    setShowActivation(true);
    // setShowForm(true);
  }, []);

  const next = useCallback(() => {
    setFetchedPage((prev) => {
      const nextPage = prev.page + 1;
      getUsers({ page: nextPage, size: prev.size });
      return { ...prev, page: nextPage };
    });
  }, [getUsers]);

  const prev = useCallback(() => {
    setFetchedPage((prev) => {
      const prevPage = prev.page > 1 ? prev.page - 1 : 1;
      getUsers({ page: prevPage, size: prev.size });
      return { ...prev, page: prevPage };
    });
  }, [getUsers]);

  const send = (data) => {
    console.log("send", data);
    data.role = +data.role;
    data.bureau = +data.bureau;
    

    // Pour la mise à jour, on ne veut pas inclure le mot de passe s'il n'a pas été modifié
    if (!selected) {
      data.password = data.password || "123456";
    } else if (data.password === "" || data.password === undefined) {
      // Supprime le champ password s'il est vide lors d'une mise à jour
      delete data.password;
    }

    let userData = { ...data };
    console.log("selected", selected);

    // If selected is not null, it means we are updating an existing user
    selected
      ? updateUser({ id: selected.id, data: userData })
          .unwrap()
          .then((res) => {
            console.log("res", res);
            toast.success("Utilisateur mis à jour avec succès");
            getUsers({ page: 1, size: 100 });
            setShowForm(false);
          })
          .catch((err) => {
            toast.error("Erreur lors de la mise à jour");
            console.log("error", err);
          })
      : postUsers({...userData, blocked: false, confirmed: true})
          .unwrap()
          .then((res) => {
            console.log("res", res);
            toast.success("Utilisateur ajouté avec succès");
            getUsers({ page: 1, size: 100 });
            setShowForm(false);
          })
          .catch((err) => {
            toast.error("Erreur lors de l'envoi");
            console.log("error", err);
          });
  };

  const deleteUserHandler = () => {
    console.log("deleteUser", selected);
    deleteUser(selected.id)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        toast.success("Utilisateur supprimé avec succès");
        getUsers({ page: 1, size: 100 });
        setShowDelete(false);
      })
      .catch((err) => {
        toast.error("Erreur lors de la suppression");
        console.log("error", err);
      });
  };

  const activateUserHandler = () => {
    console.log("activateUser", selected);
    updateUser({ id: selected.id, data: { blocked: false, confirmed: true } })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        toast.success("Utilisateur activé avec succès");
        getUsersBlocked({ page: 1, size: 100 });
        getUsers({ page: 1, size: 100 });
        setShowActivation(false);
      })
      .catch((err) => {

        toast.error("Erreur lors de l'activation de l'utilisateur");
        console.log("error", err);
      });
  };

  useEffect(() => {
    getForm(19);
    getUsers({ page: 1, size: 100 });
    getUsersBlocked({ page: 1, size: 100 });
  }, []);

  useEffect(() => {
    if (formData) {
      setFields(formData?.data?.attributes?.fields?.data || []);

      let data = {
        endpoint: "bureaus",
        page: 1,
        size: 100,
      };

      getParams(data).then((res) => {
        console.log("params", res);
        const data = res?.data?.data.map((item) => ({
          label: item.attributes.name,
          value: item.id,
        }));
        setFields((prev) =>
          prev.map((field) => {
            if (field.attributes.field_id === "bureau") {
              return {
                ...field,
                attributes: { ...field.attributes, options: data },
              };
            }
            return field;
          })
        );
      });
    }
  }, [formData]);

  console.log("selected", selected);

  return (
    <Layout title="Utilisateurs" className="p-2">
      <div>
        <Modal1 show={showForm} setShow={setShowForm}>
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold">Ajouter un utilisateur</h1>
            <button
              onClick={() => setShowForm(false)}
              className="text-red-500 text-xl">
              X
            </button>
          </div>
          <Form
            fields={fields || []}
            send={send}
            setShowForm={setShowForm}
            selectedData={selected}
          />
        </Modal1>
      </div>
      <div>
        <Modal1 show={showDelete} setShow={setShowDelete}>
          <ConfirmDelete
            send={deleteUserHandler}
            cancel={() => setShowDelete(false)}></ConfirmDelete>
        </Modal1>
      </div>

      <div>
        <Modal1 show={showActivation} setShow={setShowActivation}>
          <ConfirmActivation
            send={activateUserHandler}
            cancel={() => setShowActivation(false)}></ConfirmActivation>
        </Modal1>
      </div>
      <div className="flex w-full justify-end items-center mb-4">
        <button
          disabled={isFormLoading || fields?.length === 0}
          onClick={() => {
            setShowForm(true);
            setSelected(null);
          }}
          className="bg-primary text-white px-4 py-2 rounded-2xl">
          Ajouter un utilisateur
        </button>
      </div>

      <div className="w-full flex space-x-2 justify-around items-center mb-4">
        <span
          onClick={() => setSelectedUsers("activé")}
          className={`border-b-2 cursor-pointer ${
            selectedUsers === "activé"
              ? "border-primary text-primary font-bold"
              : "border-slate-400"
          }  w-full text-center  `}>
          Activé
        </span>
        <span
          onClick={() => setSelectedUsers("désactivé")}
          className={`border-b-2 cursor-pointer ${
            selectedUsers === "désactivé"
              ? "border-primary text-primary font-bold"
              : "border-slate-400"
          }  w-full text-center  `}>
          Désactivé
        </span>
      </div>
      {selectedUsers === "activé" ? (
        <>
          <h2 className="font-semibold text-xl  mb-4">
            {" "}
            Liste des utilisateurs activé{" "}
          </h2>
          <GridComponent
            dataSource={usersData || []}
            allowPaging
            allowSorting
            toolbar={["Search"]}
            width="auto">
            <ColumnsDirective>
              {usersGrid.map((item, index) => (
                <ColumnDirective
                  key={index}
                  {...item}
                  className="font-semibold"
                />
              ))}
              <ColumnDirective
                headerText="Action"
                width="100"
                field="action"
                template={(item) => (
                  <div className="flex justify-center items-center space-x-4">
                    {/* <button
            onClick={() => handleShowUsager(item)}
            className="w-7 h-7 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
            <FaEye />
          </button> */}
                    <button
                      onClick={() => handleShowModal(item)}
                      className="w-7 h-7 px-2 py-1 font-semibold text-white bg-primary rounded-2xl">
                      <BsPencilSquare />
                    </button>
                    <button
                      onClick={() => handleShowDelete(item)}
                      className="w-7 h-7 px-2 py-1 font-semibold text-white bg-primary rounded-2xl">
                      <MdDelete />
                    </button>
                  </div>
                )}
              />
            </ColumnsDirective>
            <Inject services={[Page, Edit, Toolbar]} />
          </GridComponent>
        </>
      ) : (
        <>
              <h2 className="font-semibold text-xl mb-4">
            {" "}
            Liste des utilisateurs désactivé{" "}
          </h2>
 
          <GridComponent
            dataSource={usersBlockedData || []}
            allowPaging
            allowSorting
            toolbar={["Search"]}
            width="auto">
            <ColumnsDirective>
              {usersGrid.map((item, index) => (
                <ColumnDirective
                  key={index}
                  {...item}
                  className="font-semibold"
                />
              ))}
              <ColumnDirective
                headerText="Action"
                width="100"
                field="action"
                template={(item) => (
                  <div className="flex justify-center items-center space-x-4">
                    {/* <button
          onClick={() => handleShowUsager(item)}
          className="w-7 h-7 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
          <FaEye />
        </button> */}
                    <button
                      onClick={() => handleShowModal(item)}
                      className="w-7 h-7 px-2 py-1 font-semibold text-white bg-primary rounded-2xl">
                      <BsPencilSquare />
                    </button>
                    <button
                      onClick={() => handleShowActivation(item)}
                      className="w-7 h-7 px-2 py-1 font-semibold text-white bg-primary rounded-2xl">
                      <BsCheck2Circle />
                    </button>
                  </div>
                )}
              />
            </ColumnsDirective>
            <Inject services={[Page, Edit, Toolbar]} />
          </GridComponent>
        </>
      )}

      <div className="w-full flex justify-end mt-4">
        <Pagination next={next} prev={prev} />
      </div>
    </Layout>
  );
};

export default Users;
